import { NgModule } from '@angular/core';
import { PipesModule } from 'cad/common/filters/pipes.module';
import { ConfirmationDashboardComponent } from 'cad/dashboard/views/content/components/confirmation-dashboard.component';
import { OfferReviewDashboardComponent } from 'cad/dashboard/views/content/components/offer-review-dashboard.component';
import { SharedModule } from 'cad/shared/shared.module';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { AddressDashComponent } from 'src/cad/dashboard/views/content/components/address-dash.component';
import { AnnouncementsDashComponent } from 'src/cad/dashboard/views/content/components/announcements-dash.component';
import { BADashComponent } from 'src/cad/dashboard/views/content/components/ba-dash.component';
import { CapRelDashComponent } from 'src/cad/dashboard/views/content/components/caprel-dash.component';
import { ContactDashComponent } from 'src/cad/dashboard/views/content/components/contact-dash.component';
import { ContractDashComponent } from 'src/cad/dashboard/views/content/components/contract-dash.component';
import { NomDashComponent } from 'src/cad/dashboard/views/content/components/nom-dash.component';
import { ReportDashComponent } from 'src/cad/dashboard/views/content/components/report-dash.component';
import { ReportFavDashComponent } from 'src/cad/dashboard/views/content/components/report-fav-dash.component';

@NgModule({
  imports: [
    SharedModule,
    PipesModule,
    PdfJsViewerModule
  ],
  declarations: [
    AddressDashComponent,
    ContactDashComponent,
    ReportDashComponent,
    ReportFavDashComponent,
    BADashComponent,
    NomDashComponent,
    ConfirmationDashboardComponent,
    AnnouncementsDashComponent,
    ContractDashComponent,
    CapRelDashComponent,
    OfferReviewDashboardComponent
  ],
  exports: [
    AddressDashComponent,
    ContactDashComponent,
    ReportDashComponent,
    ReportFavDashComponent,
    BADashComponent,
    NomDashComponent,
    ConfirmationDashboardComponent,
    AnnouncementsDashComponent,
    ContractDashComponent,
    CapRelDashComponent,
    OfferReviewDashboardComponent
  ]
})
export class DashboardComponentsModule { }
